export default __webpack_public_path__ + "static/media/Fully Drawn Yarn.91a5a33a.jpg";